import { createSlice } from '@reduxjs/toolkit'

export const heroSlice = createSlice({
  name: 'hero',
  initialState: {
    title: "",
    content: "",
    image: "",
    hasImage: false
  },
  reducers: {
    setHeroTitle: (state, action) => {
      state.title = action.payload;
    }, 
    setHeroContent: (state, action) => {
      state.content = action.payload;
    }, 
    setHeroImageURL: (state, action) => {
      state.image = action.payload;
    }, 
    setHeroImage: ( state, action ) => { 
      state.hasImage = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const { setHeroTitle, setHeroContent, setHeroImageURL, setHeroImage } = heroSlice.actions

export default heroSlice.reducer